export default __webpack_public_path__ + "static/Pink-8e08aefb2afaf0b46d24d8f783b70bd2.png";